import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getToken } from '../services/auth';
import logger from '../logger';
import Keycloak from 'keycloak-js';
import axios from "axios";
import LoginLogo from '../images/treeads-logo-negative.png';
import EULogo from '../images/eu-normal.jpg'; // Example footer logo
import HeaderLogo from '../images/efb-logo-white.png'; // Example header logo

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [keycloak, setKeycloak] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Initialize Keycloak instance only once
        const keycloakInstance = new Keycloak({
            url: 'https://keycloak-prod.maggioli-research.gr/auth/token',
            realm: 'treeads-prod',
            clientId: 'treeads-angular',
        });
        setKeycloak(keycloakInstance);
    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            await getToken(username, password);
            logger.log('Login successful');
            navigate('/user-defined-data'); // Redirect to the map after successful login
        } catch (error) {
            setError('Invalid username or password');
        }
    };

    const handleKeycloakLogin = async () => {
        const data = new URLSearchParams({
            'grant_type': 'password',
            'client_id': 'treeads-angular', // Replace with your client ID
            'username': username,
            'password': password
        });

        try {
            const keycloakUrl = 'https://keycloak-prod.maggioli-research.gr/auth/realms/treeads-prod/protocol/openid-connect/token';
            const dataHeaders = {
                'Content-Type': 'application/x-www-form-urlencoded',
            };

            // Conditionally check environment
            let response;
            if (process.env.REACT_APP_ENV !== 'development') {
                // Production or other environments
                response = await axios.post(keycloakUrl, data, {
                    headers: dataHeaders,
                });
            } else {
                // Development environment - use proxy
                const proxyUrl = 'https://cors-anywhere.herokuapp.com/';
                response = await axios.post(proxyUrl + keycloakUrl, data, {
                    headers: dataHeaders,
                });
            }

            logger.log("Keycloak response: ", response.data);

            // Store the tokens in localStorage
            localStorage.setItem('access', response.data.access_token);
            localStorage.setItem('refresh', response.data.refresh_token);

            // Log the success and redirect
            logger.log('Keycloak login successful');
            navigate('/user-defined-data'); // Redirect to your desired page after successful login

        } catch (error) {
            setError('Keycloak login failed. Please check your credentials.');
            logger.error('Keycloak login failed:', error);
        }
    };

    return (
        <>
            <header className="login-header">
                <a href="https://www.efb.gr" target="_blank" rel="noopener noreferrer">
                    <img src={HeaderLogo} alt="EFB Logo" className="header-logo" />
                </a>
                <h1>OSM-Based Mapping Tool</h1>
            </header>
            <form className="login-form" onSubmit={handleLogin}>
                <div className="login-logo-container">
                    <a href="https://treeads-project.eu/" target="_blank" rel="noopener noreferrer">
                        <img
                            src={LoginLogo}
                            alt="Login Logo"
                            className="login-logo"
                        />
                    </a>
                </div>
                <h2>Login</h2>
                {error && <p className="login-error">{error}</p>}
                <div className="form-group">
                    <label htmlFor="username">Username:</label>
                    <input
                        type="text"
                        id="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password">Password:</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <button className="login-button" type="submit">Login</button>
                <div className="keycloak-login">
                    <h5>OR</h5>
                    <button className="login-button" onClick={handleKeycloakLogin}>Login with Keycloak</button>
                </div>
            </form>
            <footer className="login-footer">
                <img src={EULogo} alt="EU Logo" className="footer-logo" />
                <p>
                    This project has received funding from the European Union’s Horizon 2020 research and innovation programme TREEADS under grant agreement No. 101036926.
                </p>
            </footer>
        </>
    );
};

export default Login;